import React from "react";
import { useTranslation } from "react-i18next";

const ContactClosingMessage = () => {
  const { t } = useTranslation();
  return (
    <section className="section topless">
      <div
        data-w-id="93bfaf27-e18e-3f5a-1541-93a1fdcbf692"
        className="container"
      >
        <div className="full-wrap">
          <div className="paragraph-wrap">
            <p className="made-28">{t("contact.closingMessage")}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactClosingMessage;
